// extracted by mini-css-extract-plugin
module.exports = {"customSubTitle":"SubTitle_customSubTitle__243ek"};